<app-new-location
  [clientId]="clientId"
  [breadCrumbInputs]="breadCrumbInputs"
  [isForPopup]="false"
></app-new-location>
